
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/news/[slug]",
      function () {
        return require("private-next-pages/community/news/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/news/[slug]"])
      });
    }
  